import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import { MdCheckCircle, MdPhoneIphone, MdNotifications, MdCardGiftcard, MdLocalOffer, MdAccountBalanceWallet } from 'react-icons/md';
import { useToast } from '../components/ToastProvider';
import pointfinityLogo from '../assets/pointfinity-logo-mark.png';
import './DownloadSection.css';

// ✏️ Update these URLs when apps are live
const appStoreUrl = '#';
const playStoreUrl = '#';

const appFeatures = [
  { icon: <MdCardGiftcard />, text: 'Track loyalty points in real time' },
  { icon: <MdLocalOffer />, text: 'Browse & claim exclusive store offers' },
  { icon: <MdAccountBalanceWallet />, text: 'Redeem points instantly at checkout' },
  { icon: <MdNotifications />, text: 'Get notified about new deals & rewards' },
];

const phoneScreenItems = [
  { label: 'My Points', value: '2,840 pts', color: '#67b7f7' },
  { label: "Today's Offer", value: '2x Points', color: '#00c853' },
  { label: 'Redeemed', value: '$48.00', color: '#f59e0b' },
];

export default function DownloadSection() {
  const toast = useToast();

  const handleStoreClick = (e, store) => {
    e.preventDefault();
    toast({ message: `${store} link coming soon! App launching shortly.`, type: 'info' });
  };
  return (
    <section className="ds-section" id="download">
      {/* Floating bg blobs */}
      <div className="ds-blob ds-blob--1" />
      <div className="ds-blob ds-blob--2" />

      <div className="container ds-inner">
        {/* Left — Phone mockup */}
        <div className="ds-mockup-wrap">
          <div className="ds-phone">
            <div className="ds-phone__notch" />
            <div className="ds-phone__screen">
              <div className="ds-phone__header">
                <img src={pointfinityLogo} alt="" className="ds-phone__logo-mark" aria-hidden="true" />
                <span className="ds-phone__logo-text">Pointfinity</span>
                <MdNotifications className="ds-phone__bell" />
              </div>
              <div className="ds-phone__greeting">
                <p>Good morning 👋</p>
                <h3>Your Rewards</h3>
              </div>
              <div className="ds-phone__hero-card">
                <div className="ds-phone__points-label">Total Points</div>
                <div className="ds-phone__points-value">2,840</div>
                <div className="ds-phone__points-sub">≈ $28.40 value</div>
              </div>
              <div className="ds-phone__stats">
                {phoneScreenItems.map((item) => (
                  <div key={item.label} className="ds-phone__stat">
                    <span className="ds-phone__stat-val" style={{ color: item.color }}>{item.value}</span>
                    <span className="ds-phone__stat-label">{item.label}</span>
                  </div>
                ))}
              </div>
              <div className="ds-phone__offer-card">
                <MdLocalOffer />
                <div>
                  <strong>Flash Deal!</strong>
                  <span>Earn 2x points today at all stores</span>
                </div>
              </div>
              <div className="ds-phone__icon-row">
                <MdPhoneIphone />
              </div>
            </div>
            {/* Floating badge */}
            <div className="ds-floating-badge ds-floating-badge--top">
              <MdCheckCircle />
              <span>Points Earned!</span>
              <strong>+120 pts</strong>
            </div>
            <div className="ds-floating-badge ds-floating-badge--bottom">
              <span className="ds-star">⭐</span>
              <span>4.9 Rating</span>
              <strong>App Store</strong>
            </div>
          </div>
        </div>

        {/* Right — Content */}
        <div className="ds-content">
          <span className="section-label ds-label">Mobile App</span>
          <h2 className="ds-title">
            Your Loyalty Rewards,<br />
            <span className="ds-title-highlight">Always in Your Pocket</span>
          </h2>
          <p className="ds-desc">
            Download the Pointfinity app and start earning rewards at every visit. Track points, grab exclusive offers, and redeem instantly — all from your phone.
          </p>

          <ul className="ds-features">
            {appFeatures.map((f) => (
              <li key={f.text}>
                <span className="ds-feature-icon">{f.icon}</span>
                <span>{f.text}</span>
              </li>
            ))}
          </ul>

          <div className="ds-btns">
            <a href={appStoreUrl} className="ds-store-btn" aria-label="Download on App Store" onClick={(e) => handleStoreClick(e, 'App Store')}>
              <FaApple className="ds-store-icon" />
              <div>
                <span>Download on the</span>
                <strong>App Store</strong>
              </div>
            </a>
            <a href={playStoreUrl} className="ds-store-btn" aria-label="Get it on Google Play" onClick={(e) => handleStoreClick(e, 'Google Play')}>
              <FaGooglePlay className="ds-store-icon" />
              <div>
                <span>Get it on</span>
                <strong>Google Play</strong>
              </div>
            </a>
          </div>

          <p className="ds-note">⭐ 4.9 rating · 10,000+ downloads · Free to use</p>
        </div>
      </div>
    </section>
  );
}
